/*
  Elan By Kristen — scroll-triggered reveal for content sections.
  Additive only: any element with [data-reveal] starts hidden (see
  elan-overrides.css) and fades/slides in once it crosses into the
  viewport. Groups sharing [data-reveal-group="x"] stagger via a CSS
  custom property so multiple cards/tiles in a row animate in sequence
  rather than all at once.

  Respects prefers-reduced-motion: reveals everything immediately, no
  observer, no transition, per the theme's existing accessibility
  convention (see elan-product-shipping-notice.liquid).
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return;

  if (reduceMotion || typeof IntersectionObserver === 'undefined') {
    targets.forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  var groupCounters = {};

  targets.forEach(function (el) {
    var group = el.getAttribute('data-reveal-group');
    if (group) {
      groupCounters[group] = groupCounters[group] || 0;
      el.style.setProperty('--elan-reveal-index', groupCounters[group]);
      groupCounters[group] += 1;
    }
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
